import Wait from "./wait";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import 'font-awesome/css/font-awesome.css'

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';


import { useEffect, useState } from "react";
import { ReportService } from "../network/reports";
import { Validator } from "../utils/validator";


export default function BaseLayout( ) {

    const [region,setRegion] = useState([])
    const [office,setOffice] = useState([])
    const [date0,setDate0] = useState('')
    const [date1,setDate1] = useState('')
    const [oid,setOid] = useState(-1)
    const [company,setCompany] = useState('Loading...')
    const [minDate,setMinDate] = useState('')
    const [maxDate,setMaxDate] = useState()
    const [payMethods,setPayMethods] = useState([])
    const [method, setMethod] = useState('all')

    const [mzunguko, setMzunguko] = useState('0.0')
    const [matarajio, setMatarajio] = useState('0.0')
    const [pending, setPending] = useState('0.0')
    const [rejeshwa, setRejeshwa] = useState('0.0')


    const [data,setData] = useState([])

    useEffect(() => {
        loadMyBranches()
    }, []);

    const loadMyBranches = () => {
        try{
            Wait.show('Regions..')
            ReportService.getMyBranches().then(r=>{
                Wait.dismiss()
                try{

                    setRegion(r.data.results)
                    setCompany(r.data.company)
                    setMinDate(r.data.date_from)
                    setMaxDate(r.data.date_to)
                    setPayMethods(r.data.pay_method)

                }catch(e){
                    console.log(e)
                }
            })
        }catch(e){
            console.log(e)
        }
    }

    const loadOffices = (selected) => {
        console.log(selected)

        var lst = []

        region.forEach(element => {
            if(selected!=='all'){
                if(selected===element.region){
                    lst = element.office
                }
            }else{
                element.office.forEach(element => {
                    lst.push(element)
                })
            }
            setOffice(lst)
        });
    }

    const loadData = () => {
        try{
            if(oid<0){ Validator.setError('oid') }
            if(date0===''){ Validator.setError('date0') }
            if(date1===''){ Validator.setError('date1'); return;}

            Wait.show('Tafadhali Subiri')
            ReportService.getMonthlyReport(oid,date0,date1,method).then(r=>{
                Wait.dismiss()

                try{
                    setData(r.data.results)
                }catch(e){
                    console.log(e)
                }
            })
        }catch(e){
            console.log(e)
            Wait.dismiss()
        }
    }

    return (
        <div
            style={{
                height: '100vh',
                width: '100vw',
                backgroundColor: '#efefef',
            }} className={'dashboard'}>

            <div>

                <div className={'row'}>
                    <div className={'col col-sm-12'} style={{height:'8vh',borderBottom:'1px solid #ddd',textAlign:'left',backgroundColor:'#fff'}}>
                        <img style={{height:'6vh',marginTop:'1vh',float:'left'}}
                            src={require('../../resources/img/logo.png')}
                            alt="logo"/>

                        <div style={{marginLeft:'1vw',fontSize:'1.8vw',height:'8vh',lineHeight:'8vh',fontWeight:'bold',float:'left',  color:'#484848'}}>
                            {company} Reports
                        </div>

                    </div>
                </div>

                <div className={'container'}>

                    <div className={'row'} style={{marginTop:'24px'}}>

                        <div className={'u-card'} style={{background:'linear-gradient(to right,#104c88,#104c77,#0874bb)', boxShadow:'none',display:'flex',alignItems:'center'}}>

                            <select style={{marginRight:'8px',padding:'5px'}} onChange={e=>loadOffices(e.target.value)}>
                                    <option value={'all'}>- Chagua Mkoa -</option>
                                    <option value={'all'}>Mikoa Yote</option>
                                    {region.map(r=><option key={r.region}>{r.region}</option>)}
                                </select>

                                <select style={{marginRight:'8px',padding:'5px'}} onChange={e=>setOid(e.target.value)} id={'oid'}>
                                    <option value={0}>- Chagua Matawi -</option>
                                    <option value={0}>Matawi Yote</option>
                                    {office.map(r=><option key={r.id} value={r.id}>{r.name}</option>)}
                                </select>

                                <input type="date" min={minDate} max={maxDate} style={{marginRight:'8px',padding:'4px'}} onChange={e=>setDate0(e.target.value)} id={'date0'}/>
                                <input type="date" min={minDate} max={maxDate} style={{marginRight:'8px',padding:'4px'}} onChange={e=>setDate1(e.target.value)} id={'date1'}/>

                                {/* <select style={{marginRight:'8px',padding:'5px'}} onChange={e=>setMethod(e.target.value)}>
                                    <option value={'all'}>- Chagua Njia ya Malipo -</option>
                                    <option value={'all'}>Zote Yote</option>
                                    {payMethods.map(r=><option key={r}>{r}</option>)}
                                </select> */}

                                <button className={'btn submit'} style={{padding:'3px'}} onClick={()=>loadData()}>
                                    <span className={'fa fa-search'}/>Tafuta
                                </button>

                        </div>

                    </div>

                    <div className={'row'}>
                            <div className={'col col-sm-12'} style={{height:'70vh',backgroundColor:'#fff',borderBottom:'1px solid #ccc',padding:0,overflowY:'auto'}}>


                            <div className={'row'} style={{marginBottom:'12px'}}>
                                <div className={'col col-sm-3'}>
                                    <div className={'u-card'} style={{margin:'2vh 0'}}>
                                        <span>Pesa Mzunguko</span>
                                        <div className={'label'}>
                                            {mzunguko}
                                        </div>
                                    </div>
                                </div>

                                <div className={'col col-sm-3'}>
                                    <div className={'u-card'} style={{margin:'2vh 0'}}>
                                        <span>Matarajio Leo</span>
                                        <div className={'label'}>
                                            {matarajio}
                                        </div>
                                    </div>
                                </div>

                                <div className={'col col-sm-3'}>
                                    <div className={'u-card'} style={{margin:'2vh 0'}}>
                                        <span>Iliyorejeshwa</span>
                                        <div className={'label'}>
                                            {rejeshwa}
                                        </div>
                                    </div>
                                </div>

                                <div className={'col col-sm-3'}>
                                    <div className={'u-card'} style={{margin:'2vh 0'}}>
                                        <span>Isiyorejeshwa</span>
                                        <div className={'label'}>
                                            {pending}
                                        </div>
                                    </div>
                                </div>

                            </div>

                                <Table className={'tb'}>
                                    <Thead>
                                        <Tr>
                                                <Th>Tarehe</Th>
                                                <Th>Opening</Th>
                                                <Th>Mtaji</Th>
                                                <Th>Marejesho</Th>
                                                <Th>Zidi</Th>
                                                <Th>Fomu</Th>
                                                <Th>VAT</Th>
                                                <Th>Faini</Th>
                                                <Th>JUMLA</Th>
                                                <Th>Gawa</Th>
                                                <Th>Matumizi</Th>
                                                <Th>Tolea</Th>
                                                <Th>Bank</Th>
                                                <Th>CODE</Th>
                                                <Th>Closing</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        {data.map((d,i)=>{
                                            return <Tr key={i} style={{textAlign:'right'}}>
                                                <Td>{d.date}</Td>
                                                <Td>{d.opening}</Td>
                                                <Td>{d.mtaji}</Td>
                                                <Td>{d.marejesho}</Td>
                                                <Td>{d.zidi}</Td>
                                                <Td>{d.fomu}</Td>
                                                <Td>{d.vat}</Td>
                                                <Td>{d.faini}</Td>
                                                <Td>{d.jumla}</Td>
                                                <Td>{d.gawa}</Td>
                                                <Td>{d.matumizi}</Td>
                                                <Td>{d.tolea}</Td>
                                                <Td>{d.bank}</Td>
                                                <Td>{d.code}</Td>
                                                <Td>{d.closing}</Td>
                                            </Tr>
                                        })}
                                    </Tbody>
                                </Table>


                                

                            </div>
                        </div>



                   

                </div>

                <Wait/>
    </div>
</div>);
}